import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface VisitasEmpresaReportDialogData {
    coordinador: string;
    year: number;
    empresaId: number | null;
    empresaNombre: string;
}

export interface VisitasEmpresaReportDialogResult {
    scope: 'empresa' | 'coordinador';
    dateFrom: Date;
    dateTo: Date;
}

@Component({
    selector: 'app-visitas-empresa-report-popup',
    templateUrl: './visitas-empresa-report-popup.component.html',
    styleUrls: ['./visitas-empresa-report-popup.component.scss'],
    standalone: false,
})
export class VisitasEmpresaReportPopupComponent {
    scope: 'empresa' | 'coordinador';
    dateFrom: Date;
    dateTo: Date;
    validationMessage: string = '';

    constructor(
        private dialogRef: MatDialogRef<VisitasEmpresaReportPopupComponent>,
        @Inject(MAT_DIALOG_DATA) public data: VisitasEmpresaReportDialogData
    ) {
        this.scope = data.empresaId ? 'empresa' : 'coordinador';
        this.dateFrom = new Date(data.year, 0, 1);
        this.dateTo = new Date(data.year, 11, 31);
    }

    get empresaDisponible(): boolean {
        return !!this.data.empresaId;
    }

    cancelar(): void {
        this.dialogRef.close();
    }

    aceptar(): void {
        this.validationMessage = '';

        if (!this.dateFrom || !this.dateTo) {
            this.validationMessage = 'Debe indicar ambas fechas.';
            return;
        }

        if (this.dateFrom > this.dateTo) {
            this.validationMessage = 'La fecha inicial no puede ser posterior a la final.';
            return;
        }

        if (this.scope === 'empresa' && !this.empresaDisponible) {
            this.validationMessage = 'Debe seleccionar una empresa.';
            return;
        }

        this.dialogRef.close({
            scope: this.scope,
            dateFrom: this.dateFrom,
            dateTo: this.dateTo,
        } as VisitasEmpresaReportDialogResult);
    }
}
